import { render, staticRenderFns } from "./IntroProjections.vue?vue&type=template&id=4f60f9e7&scoped=true"
import script from "./IntroProjections.vue?vue&type=script&lang=js"
export * from "./IntroProjections.vue?vue&type=script&lang=js"
import style0 from "./IntroProjections.vue?vue&type=style&index=0&id=4f60f9e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60f9e7",
  null
  
)

export default component.exports